import { jsx as _jsx } from "react/jsx-runtime";
import './DefaultLayout.scss';
export var DefaultLayout = function (props) {
    var children = props.children;
    return (_jsx("div", { className: "App-content", children: _jsx("div", { className: "Screen WelcomeScreen  Screen-noHeader", children: _jsx("div", { className: "Screen-content", children: children }) }) }));
};
